export class FormatsService {
    public async getFormats(): Promise<string[]>{
        return await ["csv", "xls", "xlsx"];
    }
}

export const formatsService = new FormatsService();